import { DateTime } from 'luxon';

export const parseDateTime = (value, options = {}) => {
  if (!value) {
    return null;
  }

  const { zone } = options;

  const isoDateTime = DateTime.fromISO(value, { zone });
  if (isoDateTime.isValid) {
    return isoDateTime;
  }

  const sqlDateTime = DateTime.fromSQL(value, { zone });
  if (sqlDateTime.isValid) {
    return sqlDateTime;
  }

  const jsDate = value instanceof Date ? value : new Date(value);
  if (!Number.isNaN(jsDate?.getTime?.())) {
    const dateTime = DateTime.fromJSDate(jsDate, { zone });
    if (dateTime.isValid) {
      return dateTime;
    }
  }

  return null;
};
